var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{on:{"click":function($event){return _vm.openBus(_vm.busId)}}},[_c('i',{staticClass:"fa fa-edit mr-2"}),_vm._v("Reabrir Bus ")])}
var staticRenderFns = []

export { render, staticRenderFns }